<template>
  <el-card v-loading.lock="loading" class="box-card">
    <div slot="header" class="clearfix">
      <span class="card-header">Ganti Password</span>
    </div>
    <el-alert
      v-if="success"
      :title="success"
      type="success"
      center
      show-icon
      :closable="false">
    </el-alert>
    <el-alert
      v-if="error"
      :title="error"
      type="error"
      center
      show-icon
      :closable="false">
    </el-alert>
    <el-form class="auth-form" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" size="small" label-position="left" hide-required-asterisk >
      <el-form-item label="Password Lama" prop="password_lama" :error="errorForm.password_lama">
        <el-input type="password" v-model="ruleForm.password_lama" show-password @keyup.enter.native="submitForm('ruleForm')"></el-input>
      </el-form-item>
      <el-form-item label="Password Baru" prop="password_baru" :error="errorForm.password_baru">
        <el-input type="password" v-model="ruleForm.password_baru" show-password @keyup.enter.native="submitForm('ruleForm')"></el-input>
      </el-form-item>
      <el-form-item label="Ulang Password" prop="ulang_password_baru" :error="errorForm.ulang_password_baru">
        <el-input type="password" v-model="ruleForm.ulang_password_baru" show-password @keyup.enter.native="submitForm('ruleForm')"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">Daftar</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import { auth } from '../firebase'
import firebase from 'firebase/app'

export default {
  data() {
    return  {
      ruleForm: {
        password_lama: '',
        password_baru: '',
        ulang_password_baru: ''
      },
      error: '',
      rules: {
        password_lama: [
          { required: true, message: 'Masukkan password lama', trigger: 'blur' },
        ],
        password_baru: [
          { required: true, message: 'Masukkan password baru', trigger: 'blur' }
        ],
        ulang_password_baru: [
          { required: true, message: 'Ulangi password baru', trigger: 'blur' }
        ]
      },
      errorForm: {
        password_lama: '',
        password_baru: '',
        ulang_password_baru: ''
      },
      loading: false,
      success: ''
    }
  },
  methods: {
    submitForm: function (formName) {

      this.loading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.password_baru != this.ruleForm.ulang_password_baru) {
            this.error = 'Password tidak sama'
            this.loading = false
          } else {
            var user = auth.currentUser;
            var credential = firebase.auth.EmailAuthProvider.credential(
              user.email,
              this.ruleForm.password_lama
            )

            user.reauthenticateWithCredential(credential)
              .then(() => {
                user.updatePassword(this.ruleForm.password_baru)
                  .then( () => {
                    this.loading = false
                
                    this.success = "password telah disimpan"
                  }).catch( (error) => {
                    this.loading = false
                
                    switch(error.code) {
                      case 'auth/weak-password':
                        this.error = 'Minimal password 6 karakter'
                        break;
                      default: 
                        this.error = error.message
                    }
                  });
              }).catch( (error) => {
                this.loading = false
                
                switch(error.code) {
                  case 'auth/wrong-password':
                    this.error = 'Password lama salah'
                    break;
                  default: 
                    this.error = error.message
                }
              })
          }
        } else {
          this.loading = false
        }
      });
    }
  }
}
</script>